import {Directive, ElementRef, HostListener, Input} from "@angular/core";
import {FileUploader} from "./file-uploader.class";

@Directive({standalone: true, selector: '[ng2FileSelect]'})
export class FileSelectDirective {
  @Input() uploader?: FileUploader;
  protected element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
  }

  @HostListener('change')
  onChange(): void {
    const files = this.element.nativeElement.files;
    const options = this.uploader?.options;
    this.uploader?.addToQueue(files);
    this.element.nativeElement.value = '';
  }
}
